// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Profile Container */
.profile-container {
    max-width: 500px;
    margin: 80px auto;
    padding: 40px;
    background-color: var(--clr-primary-7);
    border-radius: 16px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.8);
    text-align: center;
  }
  
  /* Profile Title */
  .profile-title {
    font-size: 2.5rem;
    color: #333333;
    margin-bottom: 30px;
    font-weight: 700;
  }
  
  /* Profile Picture Container */
  .profile-picture-container {
    position: relative;
    display: inline-block;
    margin-bottom: 30px;
  }
  
  /* Profile Picture */
  .profile-picture {
    width: 150px;
    height: 150px;
    border-radius: 50%;
    object-fit: cover;
    border: 4px solid #4A90E2;
  }
  
  /* Edit Icon */
  .edit-icon {
    position: absolute;
    bottom: 0;
    right: 0;
    background-color: #ffffff;
    border-radius: 50%;
    padding: 8px;
    color: #4A90E2;
    cursor: pointer;
    box-shadow: 0 2px 6px rgba(0,0,0,0.15);
    transition: background-color 0.3s, transform 0.3s;
  }
  
  .edit-icon:hover {
    background-color: #4A90E2;
    color: #ffffff;
    transform: scale(1.1);
  }
  
  /* Profile Details */
  .profile-details {
    text-align: left;
    margin-top: 20px;
  }
  
  .profile-field {
    display: flex;
    justify-content: space-between;
    padding: 12px 0;
    border-bottom: 1px solid #f0f0f0;
  }
  
  .field-label {
    font-weight: bold;
    color: #555555;
    font-size: large;
  }
  
  .field-value {
    color: var(--clr-white);
    font-weight: 600;
    font-size: large;
  }
  
  .profile-input {
    width: 100%;
    padding: 5px;
    border: 1px solid #ccc;
    border-radius: 4px;
  }
  
  /* Profile Actions */
  .profile-actions {
    margin-top: 30px;
  }
  
  .profile-edit-button, .profile-save-button {
    background-color: #4A90E2;
    color: white;
    border: none;
    padding: 10px 20px;
    font-size: 1rem;
    border-radius: 4px;
    cursor: pointer;
    transition: background-color 0.3s ease;
  }
  
  .profile-edit-button:hover, .profile-save-button:hover {
    background-color: #357ABD;
  }
  
  .profile-edit-button svg, .profile-save-button svg {
    margin-right: 8px;
    vertical-align: middle;
  }
  
`, "",{"version":3,"sources":["webpack://./src/components/account/Profile/ProfileComponent.css"],"names":[],"mappings":"AAAA,sBAAsB;AACtB;IACI,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;IACb,sCAAsC;IACtC,mBAAmB;IACnB,0CAA0C;IAC1C,kBAAkB;EACpB;;EAEA,kBAAkB;EAClB;IACE,iBAAiB;IACjB,cAAc;IACd,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA,8BAA8B;EAC9B;IACE,kBAAkB;IAClB,qBAAqB;IACrB,mBAAmB;EACrB;;EAEA,oBAAoB;EACpB;IACE,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,iBAAiB;IACjB,yBAAyB;EAC3B;;EAEA,cAAc;EACd;IACE,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,cAAc;IACd,eAAe;IACf,sCAAsC;IACtC,iDAAiD;EACnD;;EAEA;IACE,yBAAyB;IACzB,cAAc;IACd,qBAAqB;EACvB;;EAEA,oBAAoB;EACpB;IACE,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,eAAe;IACf,gCAAgC;EAClC;;EAEA;IACE,iBAAiB;IACjB,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;IACvB,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA,oBAAoB;EACpB;IACE,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,sCAAsC;EACxC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,iBAAiB;IACjB,sBAAsB;EACxB","sourcesContent":["/* Profile Container */\n.profile-container {\n    max-width: 500px;\n    margin: 80px auto;\n    padding: 40px;\n    background-color: var(--clr-primary-7);\n    border-radius: 16px;\n    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.8);\n    text-align: center;\n  }\n  \n  /* Profile Title */\n  .profile-title {\n    font-size: 2.5rem;\n    color: #333333;\n    margin-bottom: 30px;\n    font-weight: 700;\n  }\n  \n  /* Profile Picture Container */\n  .profile-picture-container {\n    position: relative;\n    display: inline-block;\n    margin-bottom: 30px;\n  }\n  \n  /* Profile Picture */\n  .profile-picture {\n    width: 150px;\n    height: 150px;\n    border-radius: 50%;\n    object-fit: cover;\n    border: 4px solid #4A90E2;\n  }\n  \n  /* Edit Icon */\n  .edit-icon {\n    position: absolute;\n    bottom: 0;\n    right: 0;\n    background-color: #ffffff;\n    border-radius: 50%;\n    padding: 8px;\n    color: #4A90E2;\n    cursor: pointer;\n    box-shadow: 0 2px 6px rgba(0,0,0,0.15);\n    transition: background-color 0.3s, transform 0.3s;\n  }\n  \n  .edit-icon:hover {\n    background-color: #4A90E2;\n    color: #ffffff;\n    transform: scale(1.1);\n  }\n  \n  /* Profile Details */\n  .profile-details {\n    text-align: left;\n    margin-top: 20px;\n  }\n  \n  .profile-field {\n    display: flex;\n    justify-content: space-between;\n    padding: 12px 0;\n    border-bottom: 1px solid #f0f0f0;\n  }\n  \n  .field-label {\n    font-weight: bold;\n    color: #555555;\n    font-size: large;\n  }\n  \n  .field-value {\n    color: var(--clr-white);\n    font-weight: 600;\n    font-size: large;\n  }\n  \n  .profile-input {\n    width: 100%;\n    padding: 5px;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n  }\n  \n  /* Profile Actions */\n  .profile-actions {\n    margin-top: 30px;\n  }\n  \n  .profile-edit-button, .profile-save-button {\n    background-color: #4A90E2;\n    color: white;\n    border: none;\n    padding: 10px 20px;\n    font-size: 1rem;\n    border-radius: 4px;\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n  }\n  \n  .profile-edit-button:hover, .profile-save-button:hover {\n    background-color: #357ABD;\n  }\n  \n  .profile-edit-button svg, .profile-save-button svg {\n    margin-right: 8px;\n    vertical-align: middle;\n  }\n  \n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
